import api from '../api'

const initialState = { data: null };

export const giveaway = {
    namespaced: true,
    state: initialState,
    actions: {
        getActive({ commit }){
            return api.giveaway().then(function (response) {
                    commit('getActive', response.data);
                    return Promise.resolve(response.data);
                })
                .catch(function (error) {
                    commit('getActiveFailure');
                    if(error.response.status == 404) return Promise.resolve(null);

                    api.baseErrorHendler(error);
                    return Promise.resolve(error);
                });
        },

        setActive({ commit }, giveaway){
            // console.log("SET Giveaway");
            if(giveaway != null){
                commit('getActive', giveaway);
                return Promise.resolve(giveaway);
            }
            else {
                commit('getActiveFailure');
                return Promise.reject(giveaway);
            }
        },
    },
    mutations: {
        getActiveFailure(state) {
            state.data = null;
        },
        getActive(state, data) {
            if(data.expiration != undefined) data.expirationDateTime = moment.utc() + moment.duration(data.expiration);
            state.data = data;
        }
    }
};